import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CustomValidator, fromToDate } from '../../../../../../../common/forms/custom.validators';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  VehicleAppEntityVehicleWrite
} from '../../../../../../../openapi';
import { VehicleForm } from './vehicle-form';
import { TransitPeriodItem } from '../../../../common/application-data-section/forms/application-data.form';

@Injectable()
export class PermitForOversizeVehicleTravelDataForm extends AppForm {
  constructor() {
    super({
      startDate: new FormControl(
        new Date(),
        {
          validators: [
            Validators.required,
            CustomValidator.isValidDateFormat(),
            CustomValidator.minDate(new Date())
          ]
        }),
      endDate: new FormControl(
        null,
        {
          validators: [
            Validators.required,
            CustomValidator.isValidDateFormat()
          ]
        })
    }, {
      validators: [
        fromToDate('startDate', 'endDate')
      ]
    });
  }

  public get startDate(): FormControl {
    return this.get('startDate') as FormControl;
  }

  public get endDate(): FormControl {
    return this.get('endDate') as FormControl;
  }

  public get vehicleForm(): VehicleForm | null {
    return this.get('vehicleForm') as VehicleForm | null;
  }

  public get vehicleValues(): VehicleAppEntityVehicleWrite[] {
    return this.vehicleForm?.value ? [this.vehicleForm.value] : [];
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    const value = this.value;
    delete value.vehicles;
    return value;
  }

  public startDateChange(app: ApplicationAppEntityApplicationRead | null, v: any = this.startDate.value): void {
    if (!v) {
      return;
    }

    const startDate = new Date(v);
    if (isNaN(startDate.getTime())) {
      return;
    }

    switch (app?.roadOccupationPurpose?.id) {
      // kategoria 2
      case '5f1a152d-2547-4827-b2f2-0fdd97e69c58': {
        this.setEndDateByTransitPeriod(app?.transitPeriod || '', startDate);
        break;
      }
      // kategoria 1
      case '6834397a-cb36-4ad4-9dd1-e36cc87f1915': {
        const d = new Date();
        d.setMonth(d.getMonth() + 12);
        this.endDate.setValue(d);
        break;
      }
    }
  }

  private setEndDateByTransitPeriod(v: TransitPeriodItem, startDate: Date): void {
    switch (v) {
      case '1 miesiąc': {
        startDate.setMonth(startDate.getMonth() + 1);
        break;
      }
      case '6 miesięcy': {
        startDate.setMonth(startDate.getMonth() + 6);
        break;
      }
      case '12 miesięcy': {
        startDate.setMonth(startDate.getMonth() + 12);
        break;
      }
      case '24 miesięcy': {
        startDate.setMonth(startDate.getMonth() + 24);
        break;
      }
    }

    this.endDate.setValue(startDate);
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    // kategoria 1
    if (value?.roadOccupationPurpose?.id === '6834397a-cb36-4ad4-9dd1-e36cc87f1915' && !this.vehicleForm) {
      this.addControl('vehicleForm', new VehicleForm());
    }
    this.vehicleForm?.patchFormValues(value?.vehicles?.at(0));
    super.patchFormValues(value);

    this.startDateChange(value);
  }
}
